var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":200,"width":10,"color":"primary","indeterminate":""}},[_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }